import styled from 'styled-components';
import CustomTriangle from './triangle';
import options from '../animatedVisualizations/options';

export const TextBoxWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 0 50%;
    padding-left: 50px;
    padding-right: 50px;
    margin-bottom: 20px;
    z-index: ${props => (props.fullscreen ? 100 : (options.maxSelectedCount - props.idx))};
    visibility: hidden;
    justify-content: center;
    position: relative;
`;

export const MessageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

export const Triangle = styled(CustomTriangle)`
    margin-right: 20px;
    margin-top: -5px;
`;

export const Message = styled.div`
    background-image: -moz-linear-gradient( -75deg, rgb(243,243,243) 49%, rgb(239,239,239) 51%);
    background-image: -webkit-linear-gradient( -75deg, rgb(243,243,243) 49%, rgb(239,239,239) 51%); 
    background-image: -ms-linear-gradient( -75deg, rgb(243,243,243) 49%, rgb(239,239,239) 51%); 
    box-shadow: 0px 0px 15.48px 2.52px rgba(42, 40, 40, 0.25); 
    font-size: 36px;
    text-align: center;
    padding: 30px;
    border-radius: 25px;
    width: 100%;
    height: fit-content;
    font-weight: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
    color: black;
`;


export const User = styled.div`
  box-shadow: 0px 0px 5.4px 4.6px rgba(42, 40, 40, 0.25);
  background-color: #01d094;
  width: fit-content;
  color: white;
  font-size: 1em;
  padding: 10px 20px;
  margin-left: 40px;
  margin-top: -45px;
  font-weight: bold;
  position: absolute;
  
  p {
  	margin-bottom: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/shoutboxvisualization/components.js